export default __webpack_public_path__ + "static/media/readPro_logo.e4a42cf4.png";